import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorStorageDataSearch = () => {
  const storageDataSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/storage/data/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { storageDataSearch }
}

export default InteractorStorageDataSearch
